import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class AssassinsHideout1PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.ASSASINS_HIDEOUT1;
}

export default AssassinsHideout1PoiTileEntity;
